var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-tag-card",on:{"click":_vm.click}},[_c('div',{staticClass:"t-tag-content",style:({backgroundColor:_vm.color||'#fff'})},[_c('div',{staticClass:"t-tag-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }